import { render, staticRenderFns } from "./Journey.vue?vue&type=template&id=ecec5cd4&scoped=true&"
import script from "./Journey.vue?vue&type=script&lang=ts&"
export * from "./Journey.vue?vue&type=script&lang=ts&"
import style0 from "./Journey.vue?vue&type=style&index=0&id=ecec5cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecec5cd4",
  null
  
)

export default component.exports